import { useContext, useEffect, useState } from "react";
import LogCard from "../../Components/Modal/Log";
import api from "../../api/api";
import SysLog from "../../Components/Modal/SysLog";
import Pagination from "../../Components/Pagination";

const CustomerLogsPage = () => {
    
  const [logs, setLogs] = useState([])
  const [totalPage, setTotalPage] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)
  const [success, setSuccess] = useState([true, false])
  const [isSuccess, setIsSuccess] = useState(null)
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState(false)
  const [filtered, setFiltered] = useState({type : null, state : null})


  const [filters, setFilters] = useState({
        date: null,
        status: null,
        searchTerm: null,
    });

  const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
        setSearch(true); // Reset to first page when applying filters
        setLoading(true)
  };


  
  useEffect(()=>{

    const getLogs = async ()=>{

        try{
            const Logs = await api.get('log', {
              params : {
                page : currentPage,
                ...filters
              }
            })

            console.log(Logs.data)
            setLogs([...Logs.data.logs.rows])
            setTotalPage(Math.ceil(Logs.data.logs.count / 20))
            setLoading(false)
            setSearch(false);

            

        }catch(e){

            console.log(e)
        }
    }

    getLogs()
    
  }, [currentPage, search === true])

  
  

//   useEffect(()=>{

//     const getLogs = async ()=>{

//         try{
//             const Logs = await api.get('log')

//             console.log(Logs.data)
//             setLogs([...Logs.data.logs.rows])
//             setTotalPage(Logs.data.logs.count/20)

//         }catch(e){

//             console.log(e)
//         }
//     }

//     getLogs()
    
//   }, [])

  
  return (
    <div className="min-h-screen p-6 ">
      <h1 className="mb-4 text-2xl font-bold dark:text-gray-200">Logs</h1>
      
      <div className="p-4 mb-4 bg-white rounded-lg shadow-lg dark:bg-indigo-600">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Date</label>
                <input
                    type="date"
                    name="date"
                    value={filters.date}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>
            
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Statut</label>
                <select
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                >
                    <option value="">Tous les statuts</option>
                    <option value="success">Succès</option>
                    <option value="failed">Échec</option>
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Rechercher</label>
                <input
                    type="text"
                    name="searchTerm"
                    value={filters.searchTerm}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Rechercher par action"
                />
            </div>
        </div>
        <div className="flex justify-end mt-4 space-x-4">
            <button
                onClick={handleSearch}
                className="px-4 py-2 font-semibold text-white bg-gray-800 rounded-lg shadow hover:bg-gray-700"
            >
                Rechercher
            </button>
            <button
                onClick={() => setFilters({
                    startDate: '',
                    endDate: '',
                    status: '',
                    searchTerm: '',
                })}
                className="px-4 py-2 font-semibold text-gray-700 bg-gray-100 rounded-lg shadow hover:bg-gray-200"
            >
                Réinitialiser
            </button>
        </div>
      </div>
        
      <div className="p-6 bg-gray-200 rounded-lg dark:bg-gray-700">

        <div className="flex flex-row flex-wrap items-center justify-start gap-3 px-4 my-4">
            <button 
                className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${filtered.type === 'AUTOMATION' ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                
                onClick={()=>{

                    if(filtered.type === 'AUTOMATION'){
                        setFiltered((fil)=>({...fil, type : null}))
                    }else{
                        setFiltered((fil)=>({...fil, type : 'AUTOMATION'}))
                        
                    }
                    
                }}
            >
                Automation
            </button>

            
            <button 
                className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${filtered.type === 'REQ' ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                
                onClick={()=>{

                    if(filtered.type === 'REQ'){
                        setFiltered((fil)=>({...fil, type : null}))
                    }else{
                        setFiltered((fil)=>({...fil, type : 'REQ'}))
                        
                    }
                    
                }}
            >
                Requete
            </button>
        </div>  

        <div className="flex flex-row flex-wrap items-center justify-start gap-3 px-4 my-4">
            <button 
                className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${filtered.state === 0 ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                onClick={()=>{

                    if(filtered.state === 0){
                        setFiltered((fil)=>({...fil, state : null}))
                    }else{
                        setFiltered((fil)=>({...fil, state : 0}))
                        
                    }
                    
                }}
            >
                succes
            </button>
            <button 
                className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${filtered.state === 1 ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                onClick={()=>{

                    if(filtered.state === 1){
                        setFiltered((fil)=>({...fil, state : null}))
                    }else{
                        setFiltered((fil)=>({...fil, state : 1}))
                        
                    }
                    
                }}    
            >
                Erreur
            </button>
        </div>
        
        <div className="grid gap-4 p-4 m-10">
            {logs.map(log =>{ 
            
                    if((filtered.state >= parseInt(log.level, 10) || filtered.state === null) && (filtered.type === log.customeAttribute || filtered.type === null)){
                        
                        return (
                            <SysLog key={log.id} log={log} />
                        )
                    }else{
                        
                        return true
                    }
                })
            }
        </div>
      </div>

    <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        onPageChange={(page)=>setCurrentPage(page)}
      />

    </div>
  );
};

export default CustomerLogsPage;